<template>
	<div>
		<div class="bg-primary">
			<v-container>
				<v-row>
					<v-col>
						<h2 class="white--text text-18 font-weight-medium">Seja bem vindo {{cidadao.nome}}</h2>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<div class="bg-primary">
			<v-container class="py-0">
				<v-row>
					<v-col class="py-0">
						<v-tabs v-model="tab" background-color="theme_primary" grow dark slider-color="#FFED00">
							<v-tab class="font-weight-regular">
								Beneficios
							</v-tab>
							<v-tab class="font-weight-regular">
								Serviços
							</v-tab>
							<v-tab class="font-weight-regular">
								Cadastro
							</v-tab>
						</v-tabs>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<div class="bg-main">
			<v-container>
				<v-row>
					<v-col>
						<v-tabs-items v-model="tab" >
							<v-tab-item>
								<Beneficio></Beneficio>
							</v-tab-item>
							<v-tab-item>
								<Servico></Servico>
							</v-tab-item>
							<v-tab-item>
								<Cadastro></Cadastro>
							</v-tab-item>
						</v-tabs-items>
					</v-col>
				</v-row>
			</v-container>
		</div>

	</div>
</template>

<script>
import Beneficio from '@/components/Beneficio';
import Servico from '@/components/Servico';
import Cadastro from '@/components/Cadastro';
import {mapGetters} from "vuex";

export default {
	name: 'Home',
	components: {Cadastro, Servico, Beneficio},
  created(){
    console.log('Home created');
  },
  computed: {
    ...mapGetters({
      cidadao: 'cidadao/cidadao'
    })
  },
	data: () => ({
		tab: null,
	})
}
</script>
